import { createIcon } from './create-icon'

export const CaretUpDown = createIcon({
  displayName: 'CaretUpDown',
  paths: [
    'M348.673 377.836l141.166-161.326c11.742-13.422 32.58-13.422 44.297 0l141.193 161.326c16.657 19.043 3.119 48.83-22.165 48.83h-282.355c-25.254 0-38.793-29.787-22.134-48.83z',
    'M348.673 646.165l141.166 161.323c11.742 13.423 32.58 13.423 44.297 0l141.193-161.323c16.657-19.046 3.119-48.832-22.165-48.832h-282.355c-25.254 0-38.793 29.786-22.134 48.832z'
  ]
})
